export default __webpack_public_path__ + "static/media/carosello9.2525f2a6.png";